import React from 'react';
import FinanceBanner from '../../Images/financebanner.png';
import { Row, Col, Container, Button, Tabs, Tab } from 'react-bootstrap';
import BillingPricing from '../../Images/billingpricing.png';
import { Link } from 'react-router-dom';
import ListingComponent from '../../components/ListingComponent';
import FinanceReporting from '../../Images/financereporting.png';
import JournalPayment from '../../Images/journalandpayments.png';
// import { useEffect } from "react";
// import { BsJournal } from "react-icons/bs";
const Finance = () => {
  // const {name}=useParams();
  // useEffect(()=>{
  //   if(name.toLowerCase()){

  //     <ListingComponent/>
  //   }
  // },[name])
  return (
    <>
      <div className='home'>
        <div className='home__banner home-Banners'>
          <Container>
            <Row>
              <Col md={5}>
                <h3 className='home__banner--heading'>
                  Work smarter with our <span>Accounting</span> software.
                </h3>
                <p className='home__banner--paragraph'>
                  Establish a strong foundation for financial processes,
                  corporate accounting, and financial reporting with this
                  enterprise accounting and finance platform.
                </p>

                <Button as={Link} to='/contact'>
                  Schedule A Demo
                </Button>
              </Col>
              <Col md={7}>
                <div>
                  <img src={FinanceBanner} alt='' />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className='homefinancetabs'>
          <Container>
            <div className='tabcontents'>
              <Tabs
                defaultActiveKey='home'
                id='uncontrolled-tab-example'
                className='mb-3'
              >
                <Tab eventKey='home' title='Banking'>
                  <ListingComponent
                    heading='Banking'
                    paragraph='Increases the efficiency of all the banking processes by integrating them all into a single platform. You would get fast and easy access to any required data across the entire bank and even all the departments. Every other daily task such as filling in the data or creating new reports is already automated with an ERP system of the bank.'
                  />
                </Tab>
                <Tab eventKey='autoinvoicing' title='Auto Invoicing'>
                  <ListingComponent
                    heading='Auto Invoicing'
                    paragraph='Use the Subscriptions feature to get invoices auto-generated for subscription orders. Confidently track, create, and send personalized invoices with one easy to use tool. Whether you’re working with customers across the globe, sending recurring invoices or tracking payments, we’ve got you enclosed.'
                  />
                </Tab>
                <Tab
                  eventKey='journalsandpayment'
                  title='Journals and Payments'
                >
                  <ListingComponent
                    heading='Journals and Payments'
                    image={JournalPayment}
                    paragraph=' Tuna ERP software helps you to maintain a clean and crisp ledger to avoid mismatches when closing accounts. Track income and expenses (deferred or accrued), set up notifications for period closing, and control cash flow. '
                  />
                </Tab>
                <Tab eventKey='billingandpricing' title='Billing and Pricing'>
                  <ListingComponent
                    heading='Billing and Pricing'
                    image={BillingPricing}
                    paragraph=' Tuna ERP helps you to create custom print templates for bills and set up defaults in no time. Invoice your customers and chase receivable payments easily, with payment requests and notifications via email or SMS.'
                  />
                </Tab>
                <Tab eventKey='chartsofAccounts' title='Charts of Accounts'>
                  <h4 className='navtab-heading'>Charts of Accounts</h4>
                  <ListingComponent
                    heading='Charts of Accounts'
                    image={BillingPricing}
                    paragraph='Chart of accounts is a tree view of accounts and ledgers that is required to manage your books of accounts. Tuna ERP sets up a simple chart of accounts for each Company you create, and modification per your need.'
                  />
                </Tab>
                <Tab eventKey='finance reporting' title='Finance Reporting'>
                  <ListingComponent
                    heading='Finance Reporting'
                    image={FinanceReporting}
                    paragraph=' Financial Reports are an integral part of any business operations. They provide us with a complete view of the financial status of the company. You can now have those reports at your fingertips. Now our clients do not have to be physically present in front of a PC or rely heavily on people whenever they need to review any statements. They can log in to Accounts ERP software, anytime, anywhere'
                  />
                </Tab>
              </Tabs>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Finance;
